var _path, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.882 5.99983L6.5 8.19096L6.5 3.80899L10.882 5.99983Z",
    stroke: "#4050A6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 4.5,
    x2: 6.5,
    y2: 11.5,
    stroke: "#4050A6",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 11.5,
    x2: 11.5,
    y2: 11.5,
    stroke: "#4050A6",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnd);
export default __webpack_public_path__ + "static/media/end.1de05d4ddeecb4fe2fe3504374aa14c4.svg";
export { ForwardRef as ReactComponent };